<template>
  <v-layout column class="mx-2">
    <vue-snotify></vue-snotify>
    <v-card class="mx-auto" flat>
      <v-card-title class="headline font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
      </v-card-title>
      <v-divider class="secondary"></v-divider>

      <!-- The Register Window -->
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
            <span class="grey--text text--darken-1">
              ThinkAir is undergoing a digital transformation journey ,
              investing in a new technology platform to bring schools fantastic
              digital shows and teacher’ resources to support the STEAM
              curriculum. You will be able to have a theatre experience in your
              classroom. But remember you can also visit ThinkAir for the
              real theatre experience as well as interact with all of our
              amazing STEM related exhibits.
            </span>
            <v-form ref="details" v-model="valid" lazy-validation>
              <v-row>
                <!-- The Name Field -->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model="Form.fullName"
                    outlined
                    label="Name"
                    append-icon="icons8-male-user-3"
                    hide-details="auto"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <!-- The Positon of the Teacher Field -->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="Form.position"
                    outlined
                    label="Position in School"
                    append-icon="icons8-group-task-2"
                    hide-details="auto"
                    :rules="positionRules"
                    required
                  ></v-text-field>
                </v-col>

                <!-- The email of the teacher -->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="Form.email"
                    outlined
                    label="Email Address"
                    append-icon="icons8-envelope-3"
                    hide-details="auto"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-col>
                <!-- The phone number of the teacher -->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="Form.telephoneNumber"
                    outlined
                    label="Telephone Number"
                    append-icon="icons8-phone"
                    hide-details="auto"
                    :rules="telephoneNumberRules"
                    required
                  ></v-text-field>
                </v-col>
                <!--School-->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model="Form.schoolName"
                    outlined
                    label="School Name"
                    append-icon="icons8-school-2"
                    hide-details="auto"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <!--Locations -->
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="Form.location"
                    :items="locationDropdown"
                    :filter="customFilter"
                    item-text="name"
                    outlined
                    label="Location"
                    append-icon="icons8-location-2"
                    hide-details="auto"
                    required
                  ></v-autocomplete>
                </v-col>
                <!--Free School Meal Perchentage-->
                <v-col cols="12" xs="12" sm="6" md="6"
                  v-if="getLocationWelshValue(Form.location)=='true'"> 
                  <v-text-field
                    v-model.trim="Form.freeSchoolMeals"
                    outlined
                    type="number"
                    label="Free School Meals Percentage"
                    append-icon="icons8-percentage"
                    hide-details="auto"
                    required
                    :rules="[numberRule]"
                  ></v-text-field> 
                </v-col>
                <!--WG Rating-->
                <v-col cols="12" xs="12" sm="6" md="6"
                 v-if="getLocationWelshValue(Form.location)=='true'">
                  <v-autocomplete
                    v-model="Form.WGRating"
                    :items="WelshRating"
                    item-text="name"
                    item-value="value"                   
                    outlined
                    label="Welsh Government School Categorisation"
                    hide-details="auto"
                    :rules="WGRatingRule"
                    required
                  ><v-icon slot="append" :color="Form.WGRating">icons8-goal</v-icon></v-autocomplete>
                </v-col>
                <!-- The number of participants field -->
                <!-- <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="Form.numberOfParticipants"
                    outlined
                    label="Number of Participants"
                    append-icon="icons8-user-group"
                    hide-details="auto"
                    :rules="numberOfParticipantsRules"
                    required
                  ></v-text-field>
                </v-col> -->
                <!-- The age of the group field -->
                <!-- <v-col cols="12" xs="12" sm="6" md="6">
                  <v-select
                    v-model.trim="Form.ageGroupOfParticipants"
                    :items="rangeOfGroups"
                    :menu-props="{ bottom: true, offsetY: true }"
                    outlined
                    label="Age Group of Participants"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    :rules="ageGroupOfParticipantsRules"
                    required
                  ></v-select>
                </v-col> -->
                <!-- The Delivery Data field -->
                <!-- <v-col cols="12" xs="12" sm="6" md="6" ls="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="Form.estimatedDeliveryDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="Form.estimatedDeliveryDate"
                        label="Estimated Delivery Date"
                        append-icon="mdi-calendar"
                        outlined
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="Form.estimatedDeliveryDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(Form.estimatedDeliveryDate)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col> -->
                <!-- The Marketing checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="Form.marketingCheckbox"
                    class="mx-2"
                    label="Marketing Checkbox"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                    I consent to ThinkAir contacting me via email in line with the <a href="https://www.techniquest.org/terms-conditions/privacy-policy/marketing/" target="_blank"> Marketing Privacy</a>
                  </p>
                </v-col>
                <!-- The Data processing Checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="Form.dataProcessingCheckbox"
                    class="mx-2"
                    label="Data Processing Checkbox"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                    By checking this box you agree with the storage and handling
                    of your data by this website in accordance with our <span
                      @click="dialog = true"
                      class="primary--text text-decoration-underline"
                      style="cursor: pointer !important"
                      >Privacy Policy</span
                    >
                  </p>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-window-item>
        <!-- The Enter Password/Sign IN Window -->
        <v-window-item :value="2">
          <v-card-text>
            <span class="grey--text text--darken-1">
              ThinkAir is undergoing a digital transformation journey ,
              investing in a new technology platform to bring schools fantastic
              digital shows and teacher’ resources to support the STEAM
              curriculum. You will be able to have a theatre experience in your
              classroom. But remember you can also visit ThinkAir for the
              real theatre experience as well as interact with all of our
              amazing STEM related exhibits.
            </span>
            <v-form ref="password" v-model="valid1" lazy-validation>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="userPassword"
                    outlined
                    label="Password"
                    :append-icon="show ? 'icons8-eye' : 'icons8-invisible'"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                    :rules="passwordRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="confirmPassword"
                    outlined
                    label="Confirm Password"
                    :append-icon="show1 ? 'icons8-eye' : 'icons8-invisible'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="[confirmRules, passwordConfirmationRule]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-window-item>
        <!-- The Welcome Page -->
        <v-window-item :value="3">
          <div class="pa-4 text-center" v-if="accountCreated === true">
            <h3 class="title font-weight-light mb-2">
              Welcome to ThinkAir
            </h3>
            <span class="caption grey--text">Thanks for signing up!</span>
          </div>
          <div class="pa-4 text-center" v-else>
            <h3 class="title font-weight-light mb-2">Something went wrong</h3>
            <span class="caption grey--text">Try again!</span>
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="step === 1" class="px-8" @click="step--">Back</v-btn>

        <v-btn
          v-if="step === 1"
          class="px-8"
          color="primary"
          depressed
          @click="validateDetails()"
          v-on:keyup.enter="validateDetails()"
          >Next</v-btn
        >
        <v-btn
          v-if="step === 2"
          class="px-8"
          color="primary"
          depressed
          @click="signUp"
          v-on:keyup.enter="signUp()"
          >REGISTER</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          Privacy and Terms & Conditions
          <v-spacer></v-spacer>

          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-toolbar>

        <PrivacyTermsConditions />
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">
            Read
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import PrivacyTermsConditions from "../page-components/PrivacyTermsConditions.vue";

export default {
  name: "RegisterAdmin",
  components: {
    PrivacyTermsConditions,
  },
  data: () => ({
    dialog: false,
    step: 1,
    valid: true, // details form valid
    valid1: true, // password form valid
    show: false, // show/hide password
    show1: false, // show/hide confirm password
    termsAgree: false,
    rangeOfGroups: ["18-25", "26-30", "9-12", " 13-100 "],
    locationDropdown: [
      {name:'Blaenau Gwent County Borough',welsh:'true'},
      {name:'Bridgend County Borough',welsh:'true'},
      { name: "Caerphilly County Borough",welsh:'true'},
      { name: "Cardiff",welsh:'true'},
      { name: "Carmarthenshire",welsh:'true'},
      { name: "Ceredigion",welsh:'true'},
      { name: "Conwy County Borough",welsh:'true' },
      { name: "Denbighshire",welsh:'true'},
      { name: "Flintshire",welsh:'true'},
      { name: "Gwynedd",welsh:'true'},
      { name: "Isle of Anglesey",welsh:'true'},
      { name: "Merthyr Tydfil",welsh:'true'},
      { name: "Monmouthshire",welsh:'true'},
      { name: "Neath Port Talbot",welsh:'true'},
      { name: "Newport",welsh:'true'},
      { name: "Pembrokeshire",welsh:'true'},
      { name: "Powys",welsh:'true'},
      { name: "Rhondda Cynon Taf",welsh:'true'},
      { name: "Swansea",welsh:'true'},
      { name: "The Vale of Glamorgan",welsh:'true'},
      { name: "Torfaen",welsh:'true'},
      { name: "Wrexham",welsh:'true'},
      { name: "England",welsh:'false'},
      { name: "Scotland",welsh:'false'},
      { name: "Northern Ireland",welsh:'false'},
    ],
    WelshRating:[
      {name: 'Red', value:'red'},
      {name: 'Amber', value:'amber'},
      {name: 'Yellow', value:'yellow'},
      {name: 'Green', value:'green'}
    ],
    Form: {
      fullName: "",
      email: "",
      phoneNumber: "",
      accountCreatedAt: "",
      userTypeId: "10", // set to 10 for normal user
      emailVerified: false,
      position: "",
      telephoneNumber: "",
      schoolName: "",
      location: "",
      code:"",
      // numberOfParticipants: "",
      // estimatedDeliveryDate: "",
      // ageGroupOfParticipants: "",
      marketingCheckbox: false,
      dataProcessingCheckbox: false,
      modifiedTimestamp: "",
      suspendUser: false,
      freeSchoolMeals: 0,
      WGRating:"",
    },
    numberRule: val => {
      if(val < 0) return 'Please enter a positive number'
      return true
    },
    // courseForm: {
    //   name: "",
    //   numberOfParticipants: "",
    //   ageGroupOfParticipants: "",
    //   estimatedDeliveryDate: "",
    //   userID: "",
    //   topicId: "",
    //   codeRef: "",
    //   authorized: "",
    //   createdBy: "",
    //   modifiedBy: "",
    //   createdTimestamp: "",
    //   modifiedTimestamp: "",
    // },
    userPassword: "",
    confirmPassword: "",
    accountCreated: true, // show thank you/ try gain message at the end
    //validation rules
    nameRules: [(v) => !!v || "Full name is required"],
    confirmRules: [(v) => !!v || "Confirm password required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [(v) => !!v || "Password is required"],
    positionRules: [(v) => !!v || "Position in School is require"],
    telephoneNumberRules: [(v) => !!v || "Telephone Number is required"],
    percentageOfFreeSchoolMeals: [
      (v) => !!v || "Perchentage of pupils on Free School Meals",
    ],
    numberOfParticipantsRules: [
      (v) => !!v || "Number of Participants is required",
    ],
    estimatedDeliveryDateRules: [
      (v) => !!v || "Estimate Delivery Date is required",
    ],
    ageGroupOfParticipantsRules: [
      (v) => !!v || "Age Group Of Participants is required",
    ],
    WGRatingRule:[
       (v) => !!v || "Welsh Government School Rating is required",
    ],
    menu1: false,
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "REGISTER";
        case 2:
          return "CREATE A PASSWORD";
        default:
          return "ACCOUNT CREATED";
      }
    },

    passwordConfirmationRule() {
      return () =>
        this.userPassword === this.confirmPassword || "Password must match";
    },
  },

  methods: {
    getLocationWelshValue(item){
      var self = this;
      for( var i=0; i< self.locationDropdown.length; i++){
        if(item === self.locationDropdown[i].name){
          // console.log(self.locationDropdown[i]);
          //  console.log(self.locationDropdown[i].name);
          //   console.log(self.locationDropdown[i].welsh);
          return self.locationDropdown[i].welsh;
      }
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    validateDetails() {
      if (this.$refs.details.validate()) {
        this.step++;
      } else {
        //console.log("not valid");
        this.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    goToHome() {
      //  console.log("logging out");
        this.$router.push("/").catch((err) => {});
    },
    signUp() {
      this.Form.accountCreatedAt = this.$moment().toISOString();
      if (this.$refs.password.validate()) {
        this.step++;
        // //course details:
        // this.courseForm.numberOfParticipants = this.Form.numberOfParticipants;
        // this.courseForm.ageGroupOfParticipants = this.Form.ageGroupOfParticipants;
        // this.courseForm.createdBy = this.Form.fullName;
        // this.courseForm.estimatedDeliveryDate = this.Form.estimatedDeliveryDate;

        var t = this;
        //create profile
        t.$firebase.auth
          .createUserWithEmailAndPassword(t.Form.email, t.userPassword)
          .then((user) => {
            t.Form.emailVerified = false;
            t.Form.passwordResetCode = "0"; //
            t.Form.emailVerificationCode = "1234";
            t.Form.email = t.Form.email.toLowerCase();

            //add to users table

            t.$firebase.db
              .collection("users")
              .doc(user.user.uid)
              .set(t.Form)
              .then((Result) => {})
              .catch((err) => {
                // console.log(err);
              });

            t.accountCreated = true;
            this.$snotify.success("Your account was created."); // notification component

            //send verification email
            var user = t.$firebase.auth.currentUser;

            user
              .sendEmailVerification()
              .then(function() {
                // Email sent.
              })
              .catch(function(error) {
                // An error happened.
                //  console.log("verif email: " + error);
              });

            //course form
            // t.courseForm.userID = t.$firebase.auth.currentUser.uid;

            // //add to course collection
            // t.courseForm.createdTimestamp = t.$moment().toISOString();
            // t.$firebase.db
            //   .collection("courses")
            //   .doc()
            //   .set(t.courseForm)
            //   .then((Result) => {})
            //   .catch((err) => {
            //     console.log(err);
            //   });

            //log user out
            setTimeout(function() {
              t.goToHome();
            }, 1500);
          })
          .catch((err) => {
            t.accountCreated = false;
            // console.log("error: " + err);
            this.$snotify.error(err);
          });
      } else {
        this.accountCreated = false;
        //  console.log("not valid");
        this.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
  },
};
</script>

<style scoped>
  .my-text-style >>> .v-autocomplete__slot input {
    color: red
  }
</style>